import React, { createContext, useContext, useState } from "react";

interface LoadingContextType {
  processLoading: boolean;
  setprocessLoading: (loading: boolean) => void;
}

const ProcessLoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const ProcessLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [processLoading, setprocessLoading] = useState<boolean>(false);

  return (
    <ProcessLoadingContext.Provider value={{ processLoading, setprocessLoading }}>
      {children}
    </ProcessLoadingContext.Provider>
  );
};

export const useProcessLoading = (): LoadingContextType => {
  const context = useContext(ProcessLoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};
